import { render, staticRenderFns } from "./TablePager.vue?vue&type=template&id=45d680ac&scoped=true"
import script from "./TablePager.vue?vue&type=script&lang=js"
export * from "./TablePager.vue?vue&type=script&lang=js"
import style0 from "./TablePager.vue?vue&type=style&index=0&id=45d680ac&prod&lang=scss&scoped=true"
import style1 from "./TablePager.vue?vue&type=style&index=1&id=45d680ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d680ac",
  null
  
)

export default component.exports